import { useMsal } from '@azure/msal-react';
import { IconLogin } from '@tabler/icons-react';

import { Button } from '@mantine/core';

import { loginRequest } from '../../authConfig';

export const LogInButton = () => {
    const { instance: msal } = useMsal();

    const handleLogin = () => {
        msal.loginRedirect(loginRequest).catch(error => console.log(error));
    };

    return (
        <Button
            onClick={handleLogin}
            leftSection={<IconLogin />}
            w='100%'
            variant='filled'
        >
            Log In
        </Button>
    );
};
